import React, { useEffect, useState } from 'react';
import { Divider } from '@mui/material';
import moment from 'moment-timezone';
import { DEFAULT_START_OFFSET } from '../../calendar-items/CalendarCalculator';
import { useAuth } from '../../../session/InternalAuthProvider';
import { AccountData } from '../../../api';
import { isSummerTime } from '../../../common/TimeUtils';

export const CurrentTimeDivider = () => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;

  const calculateCurrentMinutePosition = () => {
    const currentMoment = moment.tz(account.timezone);
    const currentHour = currentMoment.hour();
    const currentMinute = currentMoment.minute();

    const pixelsPerHour = 50;
    const pixelsPerMinute = pixelsPerHour / 60;
    const shouldHaveSummerTimeOffset = isSummerTime(account);
    const totalOffset = shouldHaveSummerTimeOffset ? DEFAULT_START_OFFSET + 1 : DEFAULT_START_OFFSET;
    return (currentHour - totalOffset) * pixelsPerHour + currentMinute * pixelsPerMinute;
  };

  const [dividerPosition, setDividerPosition] = useState(calculateCurrentMinutePosition());

  useEffect(() => {
    const interval = setInterval(() => {
      setDividerPosition(calculateCurrentMinutePosition());
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, []);

  return (
    <Divider
      style={{
        zIndex: 200,
        border: '1.5px solid red',
        marginTop: dividerPosition,
        position: 'absolute',
        width: `calc(100% - 3px)`,
      }}
    />
  );
};
